import {getWeatherImage} from "../../../../utils/utils";
import React, {useState} from "react";
import styled from "styled-components";
import {useSelector} from "react-redux";
import EditButton from "../../../buttons/EditButton";
import WeatherModal from "../../../modal/WeatherModal";

const Weather = ({fromWelcomeSection}) => {

    const {weather} = useSelector(state => state.project)
    const [isOpenEditModal, setIsOpenEditModal] = useState(false)

    const getText = () => {
        if (weather === "sunny"){
            return "Le projet se déroule très bien ! Votre équipe ne rencontre aucune difficulté pour le moment."
        }
        if (weather === "cloudy"){
            return "Le projet se poursuit et votre équipe a identifié quelques freins, mais rien de gênant pour l'avancée du projet."
        }
        if (weather === "rainy") {
            return " Le projet est freiné par des difficultés importantes. L'équipe projet a besoin d'aide pour lever ces freins."
        }
        if (weather === "stormy") {
            return " Le projet est stoppé ! Les difficultés rencontrées sont trop lourdes et le projet ne peut suivre son cours."
        }
        else {
            return "Il est temps de choisir une météo pour votre projet ! "
        }
    }

    return (
        <Item>
            {!fromWelcomeSection &&
                <EditButton
                    setUpdate={setIsOpenEditModal}
                    data={isOpenEditModal}
                />
            }
            <img className={"icon-weather"} src={getWeatherImage(weather)} alt="icone météo"/>
            <p className={"fw-700"}>
                {getText()}
            </p>
            {isOpenEditModal &&
            <WeatherModal
                setIsOpen={setIsOpenEditModal}
            />
            }
        </Item>
    )
}

const Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  
  .edit-btn {
    order: 3;
    align-self: flex-start;
  }
  .icon-weather {
    height: 6rem;
    width: auto;
  }
  .tooltip{
    align-self: flex-end;
  }
  
 @media (min-width: 900px) {
    flex-direction: column;
   justify-content: flex-start;
   width: 40%;
    .icon-weather {
      height: 7rem;
      align-self: center;
      width: auto;
    }
   .tooltip {
     justify-content: flex-end;
   }
   .edit-btn {
      align-self: flex-end;
      order: 0;
    }

 
  }

`

export default Weather